
import styles from './Interaction.module.scss'

import {Interaction as InteractionType} from "@/types/interaction";
import Flower from "@/Atoms/Icons/Flower";
import Candle from "@/Atoms/Icons/Candle";
import Pen from "@/Atoms/Icons/Pen";
import React, {useState, SubmitEvent} from "react";
import RoundIcon from "@/Atoms/RoundIcon";
import moment from 'moment';
import PaperPlane from "@/Atoms/Icons/PaperPlane";
import {Menu, MenuItem} from "@/Atoms/Menu/Menu";
import ExamineBlock from "@/Molecules/Interaction/ExamineBlock";

type InteractionProps = InteractionType & {
  onOpenReply: (input: string) => Promise<boolean>,
  onDelete?: (interactionId: number) => Promise<boolean>,
  onExamine?: (interactionId: number, result: boolean) => void,
  onTogglePrivate?: (interactionId: number, value: boolean) => Promise<boolean>,
  onAddHeart: (interactionId: number) => Promise<boolean>,
  editable?: boolean,
  asPreview?: boolean,
  likes?: number,
};




const FormWrapper = ({preview, children, ...props}: {
  preview: boolean,
  onSubmit: (e: SubmitEvent<HTMLFormElement>) => Promise<void>
  children: any
  className: string
}) => {
  if (preview){
    const {onSubmit, ...propsWithoutSubmit} = props
    return <div {...propsWithoutSubmit}>{children}</div>
  }
  return <form {...props}>{children}</form>
}

export default function Interaction(
  {
    id,
    type,
    status,
    datetime,
    from,
    text,
    is_private,
    hearts,
    youtube_url,
    replies,
    onOpenReply,
    onDelete,
    onTogglePrivate,
    onAddHeart,
    onExamine,
    editable,
    asPreview,
    photos,
  }: InteractionProps) {

  const [input, setInput] = useState<string>('')
  const message = (type: string|number) => {
    switch (type) {

      case 2:
      case 'candle': return 'brandde een kaars';
      case 1:
      case 'flower': return 'plaatste een bloem';
      case 3:
      case 'condolence': return '';
    }
  }

  const icon = (type: string|number): (props: any) => React.JSX.Element => {
    switch (type) {
      case 2:
      case 'candle': return Candle;
      case 1:
      case 'flower': return Flower;
      default:
      case 3:
      case 'condolence': return Pen;
    }
  }

  const handleStartReply = async (e: SubmitEvent<HTMLFormElement>) => {
      e.preventDefault();

      if (!input) {
          return;
      }
      if (onOpenReply) {
        const result = await onOpenReply(input)

        if (result) {
          setInput('')
        }
      }
  }


  const Icon = icon(type)
  const dateString = moment(datetime).fromNow();

  const isCondoleance = type === 'condolence' || type === 3;
  const showMessage = !is_private || editable


  const mappedStyle = (status: string) => {
    switch (status) {
      case 'examine': return styles.statusExamine;
      case 'refused': return styles.statusRefused;
      case 'accepted': return '';
    }
    return '';
  }

  return <div className={`${styles.interaction} ${mappedStyle(status)}`}>
    {editable && status === 'examine' && <ExamineBlock
        onClick={result => onExamine && onExamine(id, result)}
      className={styles.examineOverlay}
    />}
    <div className={styles.row}>
      <div className={styles.titleRow}>
        <div>
          <RoundIcon icon={< Icon/>}/>
        </div>
        <div className={styles.rowTitle}>
          <strong>{from}</strong> {showMessage ? message(type) : 'plaatste een privé bericht'}
        </div>
        <div>
          <span className={styles.date}>{dateString}</span>
          {editable && (<>
            {(is_private) ? <span>
              <i className={' pl-3 fa-regular fa-eye-slash mr-2'}/>(Privé)
            </span> : ''}
            <Menu menuButton={<i className={'ml-2 fa-solid fa-ellipsis-vertical px-3'}/>} transition>
              <MenuItem onClick={() => onDelete && onDelete(id)}><i className={'fa-regular fa-trash-can mr-2'}/> Dit bericht
                verwijderen</MenuItem>
              <MenuItem onClick={() => onTogglePrivate && onTogglePrivate(id, !is_private)}><i
                className={`fa-regular ${is_private ? 'fa-eye' : 'fa-eye-slash'} mr-2`}/> Dit bericht {is_private ? 'publiek' : 'privé'} maken</MenuItem>
              {status && status === 'refused' && <MenuItem onClick={() => onExamine && onExamine(id, true)}><i className={'fa-regular fa-thumbs-up mr-2'}/> Dit bericht
                  goedkeuren</MenuItem>}
              {status && status === 'accepted' && <MenuItem onClick={() => onExamine && onExamine(id, false)}><i className={'fa-regular fa-thumbs-down mr-2'}/> Dit bericht
                  afkeuren</MenuItem>}
            </Menu>
          </>)}
        </div>
      </div>
      {isCondoleance && showMessage && (
        <div className={styles.spreadRow}>
          <button className={`link ${styles.heartButton}`} onClick={() => onAddHeart(id)}>
            <i className="fa-regular fa-heart"></i> {hearts}
          </button>
          <div>
            {replies && replies.length > 0 && (<>
              {replies.length} {replies.length === 1 ? 'reactie' : 'reacties'}
            </>)}
          </div>

        </div>
      )}
    </div>
    {isCondoleance && showMessage && (<>

        <div className={styles.message}>
          {text}
        </div>
        {photos && <div className={styles.photos}>
          {photos.map((photo, index) => <div key={index}><img src={photo.url} alt={''}/></div>)}
        </div>}

        {youtube_url && <div className={styles.youtubeContainer}>
          <iframe
            width="560"
            height="315"
            src={youtube_url}
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
        }

        {replies && replies.map(({id, is_private, status, from, text, photos, datetime}, index) => {
          const showMessage = !is_private || editable
          return <div key={index} className={`${styles.reply} ${mappedStyle(status)}`}>


            {editable && status === 'examine' && <ExamineBlock
              onClick={result => onExamine && onExamine(id, result)}
              className={styles.examineOverlay}
            />}
            <div className={styles.titleRow}>
              <div className={styles.name}>
                <strong>{from}</strong> {showMessage ? '' : 'plaatste een privé bericht'}
              </div>

              {editable && (<>
                {(is_private) ? <span>
              <i className={' pl-3 fa-regular fa-eye-slash mr-2'}/>(Privé)
            </span> : ''}
                <Menu menuButton={<i className={'ml-2 fa-solid fa-ellipsis-vertical px-3'}/>} transition>
                  <MenuItem onClick={() => onDelete && onDelete(id)}><i className={'fa-regular fa-trash-can mr-2'}/> Dit
                    bericht
                    verwijderen</MenuItem>
                  <MenuItem onClick={() => onTogglePrivate && onTogglePrivate(id, !is_private)}><i
                    className={`fa-regular ${is_private ? 'fa-eye' : 'fa-eye-slash'} mr-2`}/> Dit
                    bericht {is_private ? 'publiek' : 'privé'} maken</MenuItem>
                  {status && status === 'refused' && <MenuItem onClick={() => onExamine && onExamine(id, true)}><i className={'fa-regular fa-thumbs-up mr-2'}/> Dit bericht
                      goedkeuren</MenuItem>}
                  {status && status === 'accepted' && <MenuItem onClick={() => onExamine && onExamine(id, false)}><i className={'fa-regular fa-thumbs-down mr-2'}/> Dit bericht
                      afkeuren</MenuItem>}
                </Menu>
              </>)}
            </div>
            {showMessage && <>
                <div className={styles.message}>{text}</div>
              {photos && <div className={styles.photos}>
                {photos.map((photo, index) => <div key={index}>
                  <img src={photo.url} alt={''}/>
                </div>)}
              </div>}
            </>}

            <p>

            </p>


            <div className={styles.date}>{moment(datetime).fromNow()}</div>

          </div>
        })}


        <FormWrapper preview={asPreview ?? false} className={styles.replyForm} onSubmit={handleStartReply}>
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className={styles.input}
            placeholder={`Reageer op ${from}`}
          />
          <button className={styles.sendButton}><PaperPlane/></button>
        </FormWrapper>

      </>
    )}

  </div>
}
